import * as types from 'misc/types';
import * as actions from 'misc/actions';

const sessions = (state = actions.initial(), action) => {
    switch (action.type) {
        case types.SAGA_LOGIN.REQUEST:
            return actions.load(state);
        case types.SAGA_LOGIN.SUCCESS:
            return actions.save(state, action.payload);
        case types.SAGA_LOGIN.FAILURE:
            return actions.error(state, action.error);

        // SAGA_LOGOUT.SUCCESS is located in the root reducer in reducers/index.js
        case types.SAGA_LOGOUT.REQUEST:
            return actions.load(state);
        case types.SAGA_LOGOUT.FAILURE:
            return actions.error(state, action.error);
        default:
            return state;
    }
};

export default sessions;



// WEBPACK FOOTER //
// ./src/reducers/sessions.js